import { StrictMode, useState, useEffect } from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router-dom";
import { store } from "../Redux";
import { useAppDispatch } from "../Hooks/redux";
import { startupRequest } from "../Redux/AuthRedux";
import AppRouter from "./AppRouter";

/**
 * Root application component.
 *
 * Mirrors the appointo_client pattern:
 *   1. App wraps everything in Provider + BrowserRouter.
 *   2. AppShell dispatches startupRequest on mount to restore
 *      the session from localStorage.
 *   3. Until startup completes, a loading spinner is shown.
 */

function AppShell() {
  const [ready, setReady] = useState(false);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(
      startupRequest({
        callback: () => setReady(true),
      }),
    );
  }, [dispatch]);

  if (!ready) {
    return (
      <div className="min-h-screen loading-container">
        <div className="spinner" />
        <p>Loading...</p>
      </div>
    );
  }

  return <AppRouter />;
}

export default function App() {
  return (
    <StrictMode>
      <Provider store={store}>
        <BrowserRouter>
          <AppShell />
        </BrowserRouter>
      </Provider>
    </StrictMode>
  );
}
